export default __webpack_public_path__ + "static/media/gallery7.06b5082c.png";